<template>
  <section
    class="component-mask-selector-quiz"
    resmed-component-name="mask-selector-quiz"
  >
    <div v-if="!complete" class="component">
      <div class="stage">
        <div class="card card-layers layer-02"></div>
        <div class="card card-layers layer-01"></div>
        <div class="card">
          <div class="content">
            <figure class="d-none d-md-block">
              <img
                class="img-fluid"
                v-bind:src="active.card.illustration"
                alt=""
              />
            </figure>
            <div class="question">
              <h5>{{ active.card.question[1] }}</h5>
              <h2 v-html="active.card.question[0]"></h2>
              <span v-if="active.card.sidenote">{{
                active.card.sidenote
              }}</span>
            </div>
            <div
              class="options"
              v-bind:class="{
                'is-select': active.card.options[0] === 'Select one…',
              }"
            >
              <div v-if="active.card.options[0] === 'Select one…'">
                <div
                  class="select"
                  v-bind:class="{
                    'is-selected': !ui.select.active && active.answer !== '',
                  }"
                >
                  <a
                    href="#"
                    v-on:click.prevent="ui.select.active = !ui.select.active"
                    >{{
                      active.answer === ""
                        ? "Select one…"
                        : truncate(active.answer)
                    }}</a
                  >
                  <ul v-if="ui.select.active">
                    <li
                      v-for="(item, key) in active.card.options"
                      v-if="key !== 0"
                    >
                      <a
                        v-on:click.prevent="validate(item)"
                        href="#"
                        v-bind:class="{ 'is-active': active.answer === item }"
                        >{{ item }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <a
                v-else
                v-for="item in active.card.options"
                v-on:click.prevent="validate(item)"
                href="#"
                class="btn cta-pill filled-white"
                v-bind:class="{ 'is-active': active.answer === item }"
                v-html="item"
              ></a>
            </div>
          </div>
        </div>
        <div
          class="seek"
          v-bind:class="{ 'justify-content-end': active.step === 1 }"
        >
          <a
            v-if="active.step > 1"
            href="#"
            class="btn cta-pill prev"
            v-on:click.prevent="prev"
          ></a>

          <transition
            enter-active-class="slide-in"
            leave-active-class="fade-out"
          >
            <a
              v-if="active.valid && !ui.select.active"
              href="#"
              class="btn cta-pill filled-red icon right-arrow next"
              v-on:click.prevent="next"
              >Next</a
            >
          </transition>
        </div>
        <div class="progress">
          <div class="steps">
            <h3>
              {{ active.step | format }} <span class="total">/{{ steps }}</span>
            </h3>
          </div>
          <div class="track">
            <div class="rail" ref="rail">
              <div class="marker" v-bind:style="ui.progress.marker"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <quiz-form v-else></quiz-form>
  </section>
</template>

<script>
import quizForm from "./component-mask-selector-quiz-form";
import wpApi from "../../services/wpApi";
const quiz = [
  {
    number: 1,
    question: [
      "Choose the option that best describes you:",
      "First, help us get to know you better.",
    ],
    options: [
      "Select one…",
      "I am currently using a ResMed mask for my CPAP therapy",
      "I am currently using another manufacturer’s mask for my CPAP therapy",
      "I am on therapy, and looking for a new mask",
      "I’ll start therapy soon, and looking for the best mask for me",
    ],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220119/sleep-apnea-mask-selector-what-describes-you%402x.png",
  },
  {
    number: 2,
    question: [
      "Do you tend to sleep with your mouth open and/or breathe through your mouth?",
    ],
    options: ["Yes", "No", "I don’t know"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220118/sleep-apnea-mask-selector-sleep-mouth-open%402x.png",
  },
  {
    number: 3,
    question: [
      "Do you have chronic issues that affect your breathing through your nose? <span>*</span>",
    ],
    sidenote: "* Issues such as deviated septum, allergies, etc…",
    options: ["Yes", "No", "I don’t know"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220124/sleep-apnea-mask-selector-chronic-issues%402x.png",
  },
  {
    number: 4,
    question: ["What is your sleep position style?"],
    options: ["Side ", "Back", "Stomach", "Varies, Active Sleeper"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220125/sleep-apnea-mask-selector-sleep-position%402x.png",
  },
  {
    number: 5,
    question: ["What’s your CPAP machine pressure setting?"],
    options: [
      "Less than (or equal to) 14cmH<sub>2</sub>0",
      "More than 14 cmH<sub>2</sub>0",
      "I’m not sure",
      "I don’t have a CPAP machine",
    ],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220130/sleep-apnea-mask-selector-machine-pressure%402x.png",
  },
  {
    number: 6,
    question: ["Do you have a bed partner?"],
    options: ["Yes", "No", "Prefer not to say"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220131/sleep-apnea-mask-selector-bed-partner%402x.png",
  },
  {
    number: 7,
    question: ["Are you worried about how you look in a CPAP mask?"],
    options: ["Yes", "No", "Prefer not to say"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220136/sleep-apnea-mask-selector-looks%402x.png",
  },
  {
    number: 8,
    question: [
      'Do you wake up to use the bathroom more <br class="d-none d-lg-block">than 2-3 times per night?',
    ],
    options: ["Yes", "No", "Prefer not to say"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220138/sleep-apnea-mask-selector-bathroom%402x.png",
  },
  {
    number: 9,
    question: ["Do you wear glasses?"],
    options: ["Yes", "No"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220142/sleep-apnea-mask-selector-glasses%402x.png",
  },
  {
    number: 10,
    question: [
      "Is it important for you to be able to easily read a book or watch TV with your mask on?",
    ],
    options: ["Yes", "No"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220143/sleep-apnea-mask-selector-reading%402x.png",
  },
  {
    number: 11,
    question: ["Do you have facial hair?"],
    options: ["Yes", "No"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220148/sleep-apnea-mask-selector-facial-hair%402x.png",
  },
  {
    number: 12,
    question: ["Is your face or skin easily irritated?"],
    options: ["Yes", "No", "Prefer not to say"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220150/sleep-apnea-mask-selector-skin-irritation%402x.png",
  },
  {
    number: 13,
    question: [
      "Does the idea of wearing a CPAP mask on your face make you feel uncomfortable?",
    ],
    options: ["Yes", "No", "I don’t know"],
    illustration:
      "https://dev-media.resmed.com/sites/3/20200212220156/sleep-apnea-mask-selector-mask%402x.png",
  },
];

export default {
  name: "component-mask-selector-quiz", // mask-selector-quiz
  components: {
    quizForm,
  },
  props: ["acf"],
  data() {
    return {
      steps: 13,
      complete: false, // quiz status
      active: {
        step: 1,
        answer: "",
        valid: false, // whether or not it has passed validation
      },
      answers: {},
      results: {}, // recommended masks and data
      mapped: {
        arr: [2, 3, 4, 5, 6, 7, 11, 12, 13],
        str: "",
      },
      ui: {
        // user-interface elements
        select: {
          active: false, // select element
        },
        progress: {
          // progress bar
          marker: { left: 0 },
          rail: 400,
        },
      },
      quiz: quiz,
    };
  },
  filters: {
    format(val) {
      // return val.toString().padStart(2, '0'); // padStart does not work in IE11

      let length = 2,
        string = val.toString();

      while (string.length < length) {
        string = `0${string}`;
      }

      return string;
    },
  },
  watch: {
    "active.step"(a, b) {
      let val = parseInt(this.ui.progress.marker.left),
        i;

      i =
        a > b
          ? val + this.ui.progress.rail / this.steps
          : val - this.ui.progress.rail / this.steps;
      this.ui.progress.marker.left = `${i}px`;
    },
  },
  methods: {
    validate(item) {
      item && (this.active.answer = item);
      this.active.valid = true;
      this.ui.select.active = false;
    },
    next() {
      // check validation
      if (!this.active.valid) {
        return;
      }

      // record
      this.$set(this.answers, this.active.step, this.active.answer);

      // map
      // is last question. compile concat answers
      // this.steps
      if (this.active.step === this.steps) {
        this.map();
      }

      // advance
      this.active.step < this.steps && (this.active.step += 1);

      // reset
      this.active.answer = "";
      this.active.valid = false;
      this.ui.select.active = false;

      // next question
      this.$set(this.active, "card", this.quiz[this.active.step - 1]);

      // check history after rewinding
      this.history();
    },
    prev() {
      // rewind
      this.active.step > 1 && (this.active.step -= 1);

      // previous question
      this.$set(this.active, "card", this.quiz[this.active.step - 1]);

      // check history after rewinding
      this.history();
    },
    history() {
      let answer = this.answers[this.active.step];

      if (answer) {
        this.active.answer = answer;
        this.active.valid = true;
      }
    },
    map() {
      let arr = [],
        map = ["a", "b", "c", "d"];

      for (let i of this.mapped.arr) {
        for (let prop in this.quiz[i - 1].options) {
          if (this.quiz[i - 1].options[prop] === this.answers[i]) {
            arr.push(`${i}${map[prop]}`);
          }
        }
      }

      this.mapped.str = arr.join("");
      this.masks();
    },
    masks() {
      // fetch recommended masks
      wpApi.getMaskSelectorQuizResults(this.mapped.str)
        .then((response) => {
          this.$set(this.results, "masks", response.data);

          let arr = [],
            masks = this.results.masks;

          delete masks.answers;
          masks = Object.values(masks).sort(() => {
            return 0.5 - Math.random();
          });

          for (let mask of masks) {
            for (let value of this.acf) {
              if (value.model === mask) {
                arr.push(value);
              }
            }
          }

          this.$set(this.results, "data", arr);

          // store results to display on the results page
          localStorage.setItem(
            "mask-selector-quiz-results",
            JSON.stringify(this.results)
          );

          // display form
          this.complete = true;
        });
    },
    truncate(string, words = 4) {
      // do not move this method to filters
      if (!["xs", "sm"].includes(this.$root.mode)) {
        return string;
      }

      return string.length <= length
        ? string
        : string.split(" ").slice(0, words).join(" ") + "…";
      // return (string.length <= length) ? string : string.substring(0, length) + '…';
    },
  },
  mounted() {
    this.ui.progress.rail = this.$refs.rail.offsetWidth;
  },
  created() {
    this.$set(this.active, "card", this.quiz[0]);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/base/utilities";

.component-mask-selector-quiz {
  //
}

.component {
  padding: 1.575rem 0 0 0;
  display: flex;
  justify-content: center;

  @media (min-width: 768px) {
    padding: 7rem 0 0 0;
  }

  .stage {
    position: relative;
    width: 100%;

    @media (min-width: 992px) {
      width: 856px;
    }

    @media (min-width: 1200px) {
      width: auto;
      padding: 0 5rem;
    }
  }

  .card {
    min-height: 376px;
    position: relative;
    border-radius: 8px;
    background-color: #f1f4f7;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDEyMDAgNjAwIj48dGl0bGU+YmctcXVpei1jYXJkPC90aXRsZT48ZyBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiPjxyZWN0IHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCIgZmlsbD0iI2YzZjZmOCIvPjxwYXRoIGQ9Ik0xNS4xOCw2MDBDMTUuMTgsMjc3LDI3NywxNS4xOCw2MDAsMTUuMThTMTE4NC44MiwyNzcsMTE4NC44Miw2MDBaIiBmaWxsPSIjZDJkMmQyIiBvcGFjaXR5PSIwLjE1IiBzdHlsZT0ibWl4LWJsZW5kLW1vZGU6bXVsdGlwbHkiLz48L2c+PC9zdmc+);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center calc(100% + 4rem);
    box-shadow: 0 2rem 4rem 0 rgba(0, 0, 0, 0.2);
    text-align: center;
    padding: 2rem 1rem;

    @media (min-width: 768px) {
      height: 376px;
      padding: 0 3rem;
      background-size: 110% 110%;
    }

    @media (min-width: 1200px) {
      width: 860px;
    }

    .content {
      @media (min-width: 768px) {
        transform: translateY(-7rem);
      }

      h2 {
        @media (min-width: 992px) {
          font-size: 2rem;
        }

        & + span {
          @extend %body-x-small;
          display: block;
          margin-top: -1.25rem;
          margin-bottom: 1.25rem;
        }
      }

      figure {
        margin-bottom: 2.5rem;

        img {
          height: 200px;
          margin: 0 auto;
        }
      }
    }

    .options {
      &:not(.is-select) {
        @media (max-width: 767px) {
          display: inline-flex;
          flex-direction: column;
        }
      }

      %is-active {
        color: $cc-resmed-white;
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyNnB4IiBoZWlnaHQ9IjI2cHgiIHZpZXdCb3g9IjAgMCAyNiAyNiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48IS0tR2VuZXJhdG9yOiBTa2V0Y2ggNTcuMSAoODMwODgpIC0gaHR0cHM6Ly9za2V0Y2guY29tLS0+PHRpdGxlPkFjdGl2ZSBCdXR0b25AM3g8L3RpdGxlPjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPjxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGlkPSJBQ1RJVkUtLS1NYXNrLSgxMykiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03LjAwMDAwMCwgLTYuMDAwMDAwKSI+PGcgaWQ9IkFjdGl2ZS1CdXR0b24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuMDAwMDAwLCA2LjAwMDAwMCkiPjxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiM4RjEzMkUiIGN4PSIxMyIgY3k9IjEzIiByPSIxMyIvPjxnIGlkPSJjaGVjay1zcXVhcmUtd2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuMDAwMDAwLCAxMC4wMDAwMDApIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj48cG9seWxpbmUgaWQ9IlBhdGgiIHBvaW50cz0iMCA0IDMgNyA5IDAiLz48L2c+PC9nPjwvZz48L2c+PC9zdmc+);
        background-position: 1rem center;
        background-repeat: no-repeat;
      }

      .select {
        width: 100%;
        margin: 0 auto;
        text-align: left;

        @media (min-width: 768px) {
          width: 80%;
        }

        a {
          display: block;
          padding: 0.825rem 2.5rem;
          color: $cc-resmed-black;
          @extend %body-small-bold;
        }

        > a {
          position: relative;
          border-radius: 42px;
          margin-bottom: 0.25rem;
          background-color: $cc-resmed-white;

          &:after {
            $size: 0.375rem;
            @include caret($size);
            border-top: $size solid $cc-resmed-action-red;

            right: 2rem;
            top: 1.25rem;
          }
        }

        &.is-selected {
          > a {
            @extend %is-active;
            cursor: default;
            background-color: $cc-resmed-action-red;
            padding: 0.825rem 2.5rem 0.825rem 3.25rem;
            cursor: pointer;
          }
        }

        ul {
          list-style: none;
          background-color: $cc-resmed-white;
          border-radius: 8px;
          box-shadow: 0 1rem 2rem 0 rgba(0, 0, 0, 0.3);
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 90%;
          z-index: 1;

          @media (min-width: 768px) {
            width: 80%;
          }

          li {
            a {
              &:hover,
              &:focus {
                background-color: rgba($cc-resmed-grey-15, 0.5);
              }
            }

            &:not(:last-child) {
              border-bottom: 1px solid rgba($cc-resmed-grey-15, 0.75);
            }
          }
        }
      }

      .btn {
        margin: 0.5rem;
        min-width: 136px;

        &.filled-white {
          color: $cc-resmed-black;
          padding-left: 3.25rem;
          padding-right: 3.25rem;

          @media (max-width: 767px) {
            white-space: normal;
          }

          &:hover {
            @extend %is-active;
          }

          &:focus,
          &.is-active {
            @extend %is-active;
            cursor: default;
            background-color: $cc-resmed-action-red;
          }

          // bug fix. do not remove
          @media (max-width: 575px) {
            &:hover:not(.is-active),
            &:focus:not(.is-active) {
              background-color: $cc-resmed-white;
              color: $cc-resmed-black;
              background-image: none;
            }
          }
          // end
        }
      }
    }
  }

  .card-layers {
    position: absolute;
    min-height: auto;
    padding: 0;

    &.layer-01 {
      width: 92vw;
      height: 326px;
      top: 25px;
      left: 50%;
      transform: translateX(-50%);

      @media (min-width: 576px) {
        width: 94vw;
      }

      @media (min-width: 768px) and (max-width: 991px) {
        width: 103%;
      }

      @media (min-width: 992px) {
        width: 890px;
      }
    }

    &.layer-02 {
      width: 96vw;
      height: 306px;
      top: 40px;
      left: 50%;
      transform: translateX(-50%);
      opacity: 0.825;

      @media (min-width: 768px) and (max-width: 991px) {
        width: 106%;
      }

      @media (min-width: 992px) {
        width: 912px;
      }
    }
  }

  .seek {
    padding: 0 0.625rem;
    transform: translateY(-1.25rem);
    display: flex;
    justify-content: space-between;
    min-height: 44px;

    @media (min-width: 768px) {
      padding: 0 2rem;
    }

    %animated {
      animation-duration: 0.5s;
      animation-timing-function: ease-out;
      animation-fill-mode: forwards;
    }

    .slide-in {
      animation-name: slide-in;
      @extend %animated;
    }

    .fade-out {
      opacity: 0;
    }

    @keyframes slide-in {
      from {
        transform: translateX(-20px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .next {
      transition: all 0.5s ease;

      &:hover {
        transform: translateX(6px);
      }
    }

    .prev {
      background-size: 0.825rem 0.825rem;
      background-repeat: no-repeat;
      background-image: url(#{$assets}/images/icon-left-arrow-red.svg);
      background-color: $cc-resmed-white;
      background-position: center center;
      padding: 0;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      transition: all 0.5s ease;

      &:hover {
        transform: translateX(-6px);
      }
    }
  }

  .progress {
    width: 100%;

    .steps {
      width: 100px;
      margin: 0 auto 2rem auto;
      text-align: center;

      @media (min-width: 768px) {
        margin: 1rem auto 2.25rem auto;
      }

      * {
        color: $cc-resmed-white;
        margin: 0;
      }

      .total {
        display: inline-block;
        font-size: 0.875rem;
        opacity: 0.5;
        transform: translateY(-5px);
      }
    }

    .track {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      @media (min-width: 992px) {
        background-image: url(#{$assets}/images/border-dotted-line-white.png),
          url(#{$assets}/images/border-dotted-line-white.png);
        background-position: left center, right center;
        background-repeat: no-repeat, no-repeat;
        background-size: 170px 2px, 170px 2px;
      }
    }

    .rail {
      width: 400px;
      height: 3px;
      background-color: rgba($cc-resmed-white, 0.325);
      border-radius: 2px;
      position: relative;
    }

    .marker {
      width: 40px;
      height: 5px;
      background-color: $cc-resmed-white;
      border-radius: 6px;
      position: absolute;
      top: -1px;
      left: 0;
      transition: all 1s ease-out;
    }
  }
}
</style>

<style lang="scss">
.component-mask-selector-quiz .content {
  h2 > span {
    font-size: 1.5rem;
    transform: translateY(-4px);
    display: inline-block;
  }
}
</style>